require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./personne-en-situation-de-handicap-1-9-8.json") })
        }
      }, "path---personne-en-situation-de-handicap-1-9-8");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---personne-en-situation-de-handicap-1-9-8!./.cache/json/personne-en-situation-de-handicap-1-9-8.json
// module id = 518
// module chunks = 231608221292675